import React from 'react';
import { useApiData } from '@/hooks/useApiData';
import HeroSection from '@/components/home/HeroSection';
import Marquee from '@/components/home/Marquee';
import StatBadges from '@/components/home/StatBadges';
import ProductsTeaser from '@/components/home/ProductsTeaser';
import WhyUsPreview from '@/components/home/WhyUsPreview';
import SeoContent from '@/components/home/SeoContent';
import TestimonialsSection from '@/components/home/TestimonialsSection';
import CtaSection from '@/components/home/CtaSection';

const NO_ITEMS = [];
const NO_PHOTOS = {};
const DEFAULT_HERO = '/api/files/asjk-laxmi/uploads/b326e77deaa5.webp';
const DEFAULT_SOURCING = '/api/files/asjk-laxmi/uploads/c1aebeae32a2.webp';

export default function HomePage() {
  const { data: products } = useApiData('/api/products', NO_ITEMS);
  const { data: sitePhotos } = useApiData('/api/site-photos', NO_PHOTOS);
  const { data: testimonials } = useApiData('/api/testimonials', NO_ITEMS);

  return (
    <div data-testid="home-page">
      <HeroSection heroImg={sitePhotos.hero_bg?.url || DEFAULT_HERO} />
      <Marquee />
      <StatBadges />
      <ProductsTeaser products={products} />
      <WhyUsPreview sourcingImg={sitePhotos.about_story?.url || DEFAULT_SOURCING} />
      <SeoContent />
      <TestimonialsSection testimonials={testimonials} />
      <CtaSection ctaImg={sitePhotos.cta_bg?.url || DEFAULT_HERO} />
    </div>
  );
}
